import script from "./WorkingDogList.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkingDogList.vue?vue&type=script&setup=true&lang=js"

import "./WorkingDogList.vue?vue&type=style&index=0&id=d1999812&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1999812"]])

export default __exports__